import { InjectionToken } from '@angular/core';
import { IRestApiOptions } from './interfaces/restapi-options';

export const POSITIVECINEMA_RESTAPI_PLUGIN_OPTIONS = new InjectionToken<IRestApiOptions>('restapi-options');
